import axios from 'api/axios'
import { useEffect, useState } from 'react'

/**
 * @module FetchHooks
 */

/**
 * Hook to fetch the worker data
 * @function
 * @param {UserToHandle} [user=null] - The user to make the request
 * @returns {import('common/types/connections_types').UseFetchHookResponse<OtherDataDto>}
 */
const useFetchOtherData = (user = null) => {
  const [response, setResponse] = useState([])
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const fetchData = () => {
    setLoading(true)
    setError(null)
    axios
      .get(`/otrosdatos/?user=${user ?? ''}`)
      .then((/**@type {AxiosResponse<OtherDataDto>}*/ response) => setResponse(response.data))
      .catch((error) => setError(error))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    fetchData()
  }, [user])

  return { response, error, loading }
}

export default useFetchOtherData
